<template>
  <div class="col-lg-3 col-md-4">
    <router-link class="sub-heading d-flex justify-content-center" :to="nextLink">
<!--      @mouseover="previewImage" @mouseout="hideImage"-->
      <div class="singel-product">
        <img class="img-fluid" :src="itemImage" alt="">
      </div>
    </router-link>
    <p class="text-center mb-4">{{item.name}}</p>
    <!-- <p class="text-center" :class="{'m-0': item.product_no}">{{item.name}}</p> -->
    <!-- <p class="text-center text-muted product-no" v-if="item.product_no">#{{item.product_no}}</p> -->
<!--    <button type="button" class="btn btn-primary invisible" ref="modalBtn" data-toggle="modal" data-target="#exampleModal"></button>-->
<!--    <div class="modal fade" id="exampleModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">-->
<!--      <div class="modal-dialog modal-dialog-centered" role="document">-->
<!--        <div class="modal-content">-->
<!--          <div class="modal-body">-->
<!--            <img class="img-fluid" :src="itemImage" alt="">-->
<!--&lt;!&ndash;            <p>Modal body text goes here.</p>&ndash;&gt;-->
<!--          </div>-->
<!--        </div>-->
<!--      </div>-->
<!--    </div>-->
  </div>
</template>

<script>

export default{
  name: 'ItemCard',
  props: ['item', 'nextLink'],
  computed: {
    itemImage () {
      return this.item.thumbnailUrl + '?' + Math.random() || '/static/images/p1.jpg'
    }
  },
  data () {
    return {
    }
  },
  mounted () {
    $('.singel-product').hover(function () {
      $(this).toggleClass('p-active')
    })
  },
  methods: {
    previewImage (image) {
      this.$refs.modalBtn.click()
    },
    hideImage () {
      console.log('out')
    }
  }
}
</script>

<style scoped>
.product-no {
  font-size: 90%;
}
</style>



// WEBPACK FOOTER //
// src/components/ItemCard.vue